import _ from "lodash";

export const safeJsonParse = (str: string) => {
    const result = _.attempt(JSON.parse, str);
    if (_.isError(result)) {
        console.error(`faile to parse`, str);
    }
    return _.isError(result) ? null : result;
};
